import { render } from "./ToolsBar.vue?vue&type=template&id=c165ee7a"
import script from "./ToolsBar.vue?vue&type=script&lang=js"
export * from "./ToolsBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__